import { PaymentMethodProps } from './PaymentMethod';
import PaymentMethodOption, { Variant } from './PaymentMethodOption';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../../store/types';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

export default function CashPaymentMethod(props: PaymentMethodProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Payment:PaymentMethods:CashPaymentMethod' });

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const notice = t('labels.in_store_card_payments_not_supported');

  if (props.variant === Variant.StripeElements) {
    // Secondary text like Stripe's own rows: a grey icon instead of the emoji the copy opens with.
    return (
      <PaymentMethodOption
        {...props}
        content={
          !company?.has_in_store_card_payments && (
            <p className={stripeElementsNotice} data-test="cash-in-store-card-notice">
              <AlertTriangle aria-hidden="true" className="h-[14px] w-[14px] shrink-0 mt-[2px]" />
              <span>{notice.replace(/^⚠️\s*/u, '')}</span>
            </p>
          )
        }
      />
    );
  }

  return (
    <PaymentMethodOption
      {...props}
      content={!company?.has_in_store_card_payments && <p className="text-sm mt-xs text-muted-foreground">{notice}</p>}
    ></PaymentMethodOption>
  );
}

const stripeElementsNotice = 'mt-xs flex items-start gap-xs text-[13px] leading-[18px] text-brand-text-secondary';
